/* Bottom navigation changes panels only after the current panel has left. */
(() => {
  if (window.akOverlaySwitchReady) return;
  window.akOverlaySwitchReady = true;
  let pending = null;
  let observer = null;
  let replay = false;
  const selectors = '.ak-bottom-nav .ak-bottom-menu-box, .ak-bottom-nav .ak-mobile-menu-trigger, .ak-bottom-nav .ak-bottom-search-box, .ak-bottom-nav .ak-bottom-cart-box';
  const kind = button => button.matches('.ak-bottom-menu-box,.ak-mobile-menu-trigger') ? 'menu' : button.matches('.ak-bottom-search-box') ? 'search' : 'cart';
  const entries = () => [
    ...Array.from(document.querySelectorAll('#ak-directory-menu,#ak-mobile-directory')).map(el => ({el,kind:'menu',active:el.getAttribute('aria-hidden') === 'false'})),
    ...Array.from(document.querySelectorAll('.ak-search-overlay')).map(el => ({el,kind:'search',active:el.classList.contains('is-open') || (!el.hasAttribute('x-cloak') && getComputedStyle(el).display !== 'none')})),
    ...Array.from(document.querySelectorAll('[data-ak-desktop-cart-overlay],[data-ak-mobile-cart-overlay]')).map(el => ({el,kind:'cart',active:!el.hidden}))
  ];
  function close(entry) {
    if (entry.kind === 'menu') window.dispatchEvent(new CustomEvent('ak:close-directory'));
    if (entry.kind === 'search' && entry.el.classList.contains('is-open')) {
      entry.el.dispatchEvent(new CustomEvent('ak-close-search',{bubbles:true}));
    }
    if (entry.kind === 'cart' && !entry.el.classList.contains('is-closing')) {
      if (entry.el.hasAttribute('data-ak-desktop-cart-overlay')) window.akCloseDesktopCart?.();
      else window.akCloseMobileCart?.();
    }
  }
  function advance() {
    if (!pending) return;
    const others = entries().filter(entry => entry.active && entry.kind !== pending.kind);
    if (others.length) {
      others.forEach(entry => {
        if (entry.kind !== 'menu' || !entry.el.classList.contains('is-closing')) close(entry);
      });
      return;
    }
    observer?.disconnect();
    observer = null;
    const button = pending.button;
    pending = null;
    if (!button.isConnected) return;
    replay = true;
    try { button.click(); } finally { replay = false; }
  }
  window.addEventListener('click', event => {
    if (replay || !(event.target instanceof Element)) return;
    const button = event.target.closest(selectors);
    if (!button) return;
    const next = kind(button);
    if (!pending && !entries().some(entry => entry.active && entry.kind !== next)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    pending = {button:event.target.closest('a,button') || button.querySelector('a,button') || button,kind:next};
    if (!observer) {
      observer = new MutationObserver(advance);
      observer.observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['class','style','hidden','aria-hidden']});
    }
    advance();
  }, true);
  window.addEventListener('ak:navigation-start', () => {
    pending = null;
    observer?.disconnect();
    observer = null;
  });
})();
